import type {ProcessingError} from './types'

export const updateAdditional = (error: ProcessingError, key: string, value: string | number | boolean) => {
  if (!error.additional) {
    error.additional = {}
  }

  error.additional[key] = value

  return error
}

export const getLoadErrorSrc = (error: ProcessingError): string | undefined => error.additional?.src

export const sendOnly = (coefficient: number) => coefficient > Math.random()
